<template>
  <UiSection id="info" class="dark flex flex-wrap justify-around text-center">
    <div class="flex flex-col items-center my-8 p-2 space-y-6 w-full sm:w-1/2 md:w-1/3 xl:w-1/6 max-w-xs">
      <video class="rounded-lg" src="../../assets/info_location.mp4" poster="../../assets/info_location.jpg" preload="auto" loop muted @mouseover="$event.currentTarget.play()" @mouseleave="$event.currentTarget.pause()" />
      <div class="space-y-2">
        <p class="text-2xl text-yellow-400 font-extrabold uppercase" v-text="t('locationHeader')" />
        <p class="flex items-center justify-center text-xl font-bold">
          <i class="flag-icon flag-icon-ru flag-icon-squared mr-1 rounded-full" />
          <span v-text="t('locationName')" />
        </p>
        <p class="text-base text-gray-500" v-text="t('locationDescription')" />
      </div>
      <UiButton class="w-48 text-base bg-gradient-to-br from-blue-600 to-blue-800 hover:from-blue:500 text-white" href="https://electronic-visa.kdmid.ru/spb_home_en.html" v-text="t('locationButton')" />
    </div>

    <div class="flex flex-col items-center my-8 p-2 space-y-6 w-full sm:w-1/2 md:w-1/3 xl:w-1/6 max-w-xs">
      <video class="rounded-lg" src="../../assets/info_place.mp4" poster="../../assets/info_place.jpg" loop muted @mouseover="$event.currentTarget.play()" @mouseleave="$event.currentTarget.pause()" />
      <div class="space-y-2">
        <p class="text-2xl text-yellow-400 font-extrabold uppercase" v-text="t('placeHeader')" />
        <p class="flex items-center justify-center text-xl font-bold">
          <img class="mr-1 h-5" src="../../assets/colizeum-icon.svg" alt="" />
          <span v-text="t('placeName')" />
        </p>
        <p class="text-base text-gray-500">
          <a class="" href="https://colizeumarena.com/club/colizeum_parkpobedi" target="_blank" v-text="t('placeDescription')" />
        </p>
      </div>
      <UiButton class="w-48 text-base bg-gradient-to-br from-blue-600 to-blue-800 hover:from-blue:500 text-white" href="https://goo.gl/maps/w3TzxmgvDk3eBSGs5" v-text="t('placeButton')" />
    </div>

    <div class="flex flex-col items-center my-8 p-2 space-y-6 w-full sm:w-1/2 md:w-1/3 xl:w-1/6 max-w-xs">
      <img class="rounded-lg" src="../../assets/info_host.jpg" />
      <div class="space-y-2">
        <p class="text-2xl text-yellow-400 font-extrabold uppercase" v-text="t('hostHeader')" />
        <p class="flex items-center justify-center text-xl font-bold">
          <img class="mr-1 h-5" src="../../assets/factory-icon.png" alt="" />
          <span v-text="t('hostName')" />
        </p>
        <p class="text-base text-gray-500">
          <a class="text-blue-400 hover:text-blue-300" href="https://factory-esports.com" target="_blank" v-text="t('hostDescription')" />
        </p>
      </div>
      <UiButton class="w-48 text-base bg-gradient-to-br from-blue-600 to-blue-800 hover:from-blue:500 text-white" href="mailto:deathmatchtv@outlook.com" v-text="t('hostButton')" />
    </div>

    <div class="flex flex-col items-center my-8 p-2 space-y-6 w-full sm:w-1/2 md:w-1/3 xl:w-1/6 max-w-xs">
      <video class="rounded-lg" src="../../assets/info_game.mp4" poster="../../assets/info_game.jpg" loop muted @mouseover="$event.currentTarget.play()" @mouseleave="$event.currentTarget.pause()" />
      <div class="space-y-2">
        <p class="text-2xl text-yellow-400 font-extrabold uppercase" v-text="t('gameHeader')" />
        <p class="flex items-center justify-center text-xl font-bold">
          <img class="mr-1 h-6" src="../../assets/diabotical-icon.png" alt="" />
          <span v-text="t('gameName')" />
        </p>
        <p class="text-base text-gray-500">
          <a class="text-blue-400 hover:text-blue-300" href="https://diabotical.com" target="_blank" v-text="t('gameDescription')" />
        </p>
      </div>
      <UiButton class="w-48 text-base bg-gradient-to-br from-blue-600 to-blue-800 hover:from-blue:500 text-white" href="https://www.epicgames.com/store/product/diabotical" v-text="t('gameButton')" />
    </div>

    <div class="flex flex-col items-center my-8 p-2 space-y-6 w-full sm:w-1/2 md:w-1/3 xl:w-1/6 max-w-xs">
      <video class="rounded-lg" src="../../assets/info_solo.mp4" poster="../../assets/info_solo.jpg" loop muted @mouseover="$event.currentTarget.play()" @mouseleave="$event.currentTarget.pause()" />
      <div class="space-y-2">
        <p class="text-2xl text-yellow-400 font-extrabold uppercase" v-text="t('day1Header')" />
        <p class="flex items-center justify-center text-xl font-bold">
          <img class="mr-1 h-5" src="../../assets/duel_icon.png" alt="" />
          <span v-text="t('day1Name')" />
        </p>
        <p class="text-base text-gray-500">
          <a class="text-blue-400 hover:text-blue-300" href="https://savvytime.com/converter/msk-to-cest-gmt/oct-3-2020/10am" target="_blank" v-text="t('day1Description')" />
        </p>
      </div>
      <UiButton class="w-48 text-base bg-gradient-to-br from-blue-600 to-blue-800 hover:from-blue:500 text-white" v-text="t('day1Button')" @click="modals.signup = true" />
    </div>

    <div class="flex flex-col items-center my-8 p-2 space-y-6 w-full sm:w-1/2 md:w-1/3 xl:w-1/6 max-w-xs">
      <video class="rounded-lg" src="../../assets/info_team.mp4" poster="../../assets/info_team.jpg" loop muted @mouseover="$event.currentTarget.play()" @mouseleave="$event.currentTarget.pause()" />
      <div class="space-y-2">
        <p class="text-2xl text-yellow-400 font-extrabold uppercase" v-text="t('day2Header')" />
        <p class="flex items-center justify-center text-xl font-bold">
          <img class="mr-1 h-5" src="../../assets/tdm_icon.png" alt="" />
          <span v-text="t('day2Name')" />
        </p>
        <p class="text-base text-gray-500">
          <a class="text-blue-400 hover:text-blue-300" href="https://savvytime.com/converter/msk-to-cest-gmt/oct-3-2020/10am" target="_blank" v-text="t('day2Description')" />
        </p>
      </div>
      <UiButton class="w-48 text-base bg-gradient-to-br from-blue-600 to-blue-800 hover:from-blue:500 text-white" v-text="t('day2Button')" @click="modals.signup = true" />
    </div>
  </UiSection>
</template>

<script>
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { menu, modals } from '../../store.js'

  export default {
    name: 'SectionInfo',
    setup() {
      const { t } = useI18n({
        messages: {
          en: {
            header: 'Info',
            locationHeader: 'Location',
            locationName: 'Saint Petersburg',
            locationDescription: 'Varshavskaya Street, 23/3',
            locationButton: 'Get E-VISA',
            placeHeader: 'Place',
            placeName: 'COLIZEUM',
            placeDescription: 'colizeumarena.com',
            placeButton: 'Open map',
            hostHeader: 'Host',
            hostName: 'Factory Esports',
            hostDescription: 'factory-esports.com',
            hostButton: 'Contact',
            gameHeader: 'Game',
            gameName: 'Diabotical',
            gameDescription: 'diabotical.com',
            gameButton: 'Play',
            day1Header: 'October 3',
            day1Name: 'Duel Invitational',
            day1Description: '10:00 – 22:00 MSK',
            day1Button: 'Sign up',
            day2Header: 'October 4',
            day2Name: 'Team Draft',
            day2Description: '10:00 – 22:00 MSK',
            day2Button: 'Sign up',
          },
          ru: {
            header: 'Информация',
            locationHeader: 'Локация',
            locationName: 'Санкт-Петербург',
            locationDescription: 'ул. Варшавская, 23к3',
            locationButton: 'E-VISA',
            placeHeader: 'Место',
            placeName: 'COLIZEUM',
            placeDescription: 'colizeumarena.com',
            placeButton: 'Карта',
            hostHeader: 'Организатор',
            hostName: 'Factory Esports',
            hostDescription: 'factory-esports.com',
            hostButton: 'Связаться',
            gameHeader: 'Игра',
            gameName: 'Diabotical',
            gameDescription: 'diabotical.com',
            gameButton: 'Играть',
            day1Header: '3 октября',
            day1Name: 'Дуэли',
            day1Description: '10:00 – 22:00 МСК',
            day1Button: 'Участвовать',
            day2Header: '4 октября',
            day2Name: 'Команды',
            day2Description: '10:00 – 22:00 МСК',
            day2Button: 'Участвовать',
          },
        },
      })

      menu.info = {
        name: computed(() => t('header')),
        icon: 'fa fa-info-circle',
      }

      return { modals, t }
    },
  }
</script>
